import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FinishingForProductionSchedule} from '@domain/production-schedule/finishing-for-production-schedule';
import {AssertionUtils, TranslateService} from '@vdw/angular-component-library';

@Component({
  templateUrl: './finishing-details.component.html',
  styleUrls: ['./finishing-details.component.scss']
})
export class FinishingDetailsComponent {
  public finishing: FinishingForProductionSchedule;
  private translate: TranslateService;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    translate: TranslateService
  ) {
    this.finishing = data.finishing;
    this.translate = translate;
  }

  public getFinishingType(): string {
    return !AssertionUtils.isNullOrUndefined(this.finishing.finishingType) ? this.translate.instant(`TEXTILE_DATA.FINISHING_TEMPLATE.FINISHINGTYPE_OPTIONS.${this.finishing.finishingType}`) : '';
  }

  public getFinishingLabel(): string {
    const translation = !AssertionUtils.isEmpty(this.finishing.labels) ? this.translate.instant('GENERAL.CONDITION.YES') : this.translate.instant('GENERAL.CONDITION.NO');
    return !AssertionUtils.isNullOrUndefined(this.finishing.labels) ? translation : '';
  }

  public getCutbarBefore(): string {
    let cutbarBeforeValue = '';
    const millimeterTranslationKey = 'GENERAL.UNIT.MILLIMETER';
    const picksTranslationKey = 'GENERAL.UNIT.PICKS';
    if (this.canShowLengthOfCutbarBefore()) {
      this.translate.get([millimeterTranslationKey, picksTranslationKey]).subscribe((translations: any) => {
        const lengthOfCutbarBeforeInMillimeters = this.getLengthOfCutbarBeforeInMillimeters();
        const lengthOfCutbarBeforeInNumberOfPicks = this.getLengthOfCutbarBeforeInNumberOfPicks();
        cutbarBeforeValue = `${lengthOfCutbarBeforeInMillimeters} ${translations[millimeterTranslationKey]} / ${lengthOfCutbarBeforeInNumberOfPicks} ${translations[picksTranslationKey]}`;
      });
    }
    return cutbarBeforeValue;
  }

  public getCutbarAfter(): string {
    let cutbarAfterValue = '';
    const millimeterTranslationKey = 'GENERAL.UNIT.MILLIMETER';
    const picksTranslationKey = 'GENERAL.UNIT.PICKS';
    if (this.canShowLengthOfCutbarAfter()) {
      this.translate.get([millimeterTranslationKey, picksTranslationKey]).subscribe((translations: any) => {
        const lengthOfCutbarAfterInMillimeters = this.getLengthOfCutbarAfterInMillimeters();
        const lengthOfCutbarAfterInNumberOfPicks = this.getLengthOfCutbarAfterInNumberOfPicks();
        cutbarAfterValue = `${lengthOfCutbarAfterInMillimeters} ${translations[millimeterTranslationKey]} / ${lengthOfCutbarAfterInNumberOfPicks} ${translations[picksTranslationKey]}`;
      });
    }
    return cutbarAfterValue;
  }

  private canShowLengthOfCutbarBefore(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.finishing.cutbarsInformation) && this.finishing.cutbarsInformation.hasAddedCutbarBefore();
  }

  private getLengthOfCutbarBeforeInMillimeters(): number {
    return this.finishing.cutbarsInformation.getLengthOfCutbarBeforeInMillimeters();
  }

  private getLengthOfCutbarBeforeInNumberOfPicks(): number {
    return this.finishing.cutbarsInformation.getLengthOfCutbarBeforeInNumberOfPicks();
  }

  private canShowLengthOfCutbarAfter(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.finishing.cutbarsInformation) && this.finishing.cutbarsInformation.hasAddedCutbarAfter();
  }

  private getLengthOfCutbarAfterInMillimeters(): number {
    return this.finishing.cutbarsInformation.getLengthOfCutbarAfterInMillimeters();
  }

  private getLengthOfCutbarAfterInNumberOfPicks(): number {
    return this.finishing.cutbarsInformation.getLengthOfCutbarAfterInNumberOfPicks();
  }
}
